import React, { useEffect, useState } from "react";
import styles from "./NewUIHeader.module.scss";
import logoimg from "../../../assets/images/Mountain-mystries-logo.png";
import AccountDetailDropdown from "../../Login/AccountDetailDropdown";
import LoginBtn from "../../Login/LoginBtn";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { showSuccessToast } from "../../../assets/toastUtils";
import NewUILoginBtn from "../NewUILogin/NewUILoginBtn";
import NewUIAccountDetailDropdown from "../NewUILogin/NewUIAccountDetailsDropdown";

const NewUiHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userType, setUserType] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    const storedUserType = localStorage.getItem("userType");
    if (storedUserType) {
      setUserType(storedUserType);
    }
  }, []);

  useEffect(() => {
    // Check if token is present in local storage
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleLogout = async (e) => {
    e.preventDefault();
    localStorage.clear();
    navigate("/");
    window.location.reload();
    showSuccessToast("Logged Out Successful");
    // alert("test")
    // setLoader(true);
    // const token = localStorage.getItem("token");
    // const myHeaders = new Headers();

    // myHeaders.append("key", "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1");
    // myHeaders.append("Authorization", `Bearer ${token}`);
    // const requestOptions = {
    //   method: "POST",
    //   headers: myHeaders,
    //   redirect: "follow",
    // };

    // try {
    //   const response = await fetch(
    //     "https://extranet.travcatalyst.com/api/v1/customers/logout",
    //     requestOptions
    //   );
    //   const result = await response.json();
    //   console.log(result);

    //   showSuccessToast("Logged Out Successful")
    //   localStorage.clear()
    //   setIsLoggedIn(false);
    //   // navigate("/login")
    // } catch (error) {
    //   console.error(error);
    // } finally {
    //   setLoader(false);
    // }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <>
      <div className={styles.new_ui_header} id="NewUIHeader">
        <div className="container">
          <div className={styles.flex_between}>
            <div className={styles.first_col}>
              <div className={styles.logo}>
                <Link to={"/"}>
                  <img src={logoimg} alt="Logo" className={styles.logo} />
                </Link>
              </div>{" "}
              <nav className={styles.nav}>
                <Link
                  to="/"
                  className={location.pathname === "/" ? styles.active : ""}
                >
                  Holidays
                </Link>
                <Link
                  to="/accommodation"
                  className={
                    location.pathname === "/accommodation" ? styles.active : ""
                  }
                >
                  Hotels
                </Link>
                <Link
                  to="/activities"
                  className={
                    location.pathname === "/activities" ? styles.active : ""
                  }
                >
                  Activities
                </Link>
                <Link
                  to="/transport"
                  className={
                    location.pathname === "/transport" ? styles.active : ""
                  }
                >
                  Transport
                </Link>
                <Link
                  to="/all-destinations"
                  className={
                    location.pathname === "/all-destinations"
                      ? styles.active
                      : ""
                  }
                >
                  Destination
                </Link>
                <Link
                  to="/themes"
                  className={
                    location.pathname === "/themes" ? styles.active : ""
                  }
                >
                  Themes
                </Link>
              </nav>
            </div>
            <div className={styles.second_col}>
              <Link to={"tel:+9198050-21966"} className="tooltip">
                {/* <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="27"
                    height="27"
                    stroke="#291711"
                  />
                  <mask
                    id="mask0_6863_9517"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="6"
                    y="6"
                    width="16"
                    height="16"
                  >
                    <rect x="6" y="6" width="16" height="16" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_6863_9517)">
                    <path
                      d="M18.9601 19.6667C17.7038 19.6667 16.4416 19.3746 15.1736 18.7903C13.9057 18.2061 12.7397 17.382 11.6756 16.318C10.6158 15.2539 9.79381 14.0889 9.20959 12.823C8.62536 11.5572 8.33325 10.2962 8.33325 9.03984C8.33325 8.83984 8.39992 8.67206 8.53325 8.5365C8.66659 8.40106 8.83325 8.33334 9.03325 8.33334H11.2076C11.3759 8.33334 11.5244 8.38828 11.6531 8.49817C11.7818 8.60795 11.8636 8.74361 11.8986 8.90517L12.2808 10.8667C12.3072 11.0487 12.3016 11.2051 12.2641 11.3358C12.2264 11.4666 12.1589 11.5764 12.0614 11.6653L10.5218 13.1642C10.7695 13.6179 11.0526 14.0472 11.3711 14.452C11.6894 14.8567 12.0341 15.2432 12.4051 15.6115C12.7709 15.9774 13.1598 16.3172 13.5718 16.6308C13.9838 16.9445 14.4286 17.2364 14.9064 17.5065L16.4024 15.9975C16.5068 15.8889 16.6331 15.8128 16.7814 15.7692C16.9296 15.7256 17.0837 15.7149 17.2436 15.7372L19.0948 16.1142C19.2631 16.1586 19.4005 16.2445 19.5069 16.3718C19.6134 16.4992 19.6666 16.6436 19.6666 16.8052V18.9667C19.6666 19.1667 19.5989 19.3333 19.4634 19.4667C19.3279 19.6 19.1601 19.6667 18.9601 19.6667Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </svg> */}

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="35"
                    height="35"
                    stroke="#291711"
                  />
                  <mask
                    id="mask0_6863_9517"
                    maskUnits="userSpaceOnUse"
                    x="8"
                    y="8"
                    width="20"
                    height="20"
                  >
                    <rect x="8" y="8" width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_6863_9517)">
                    <path
                      d="M24.2 25.0833C22.6296 25.0833 21.0519 24.7182 19.4669 23.9879C17.8821 23.2576 16.4246 22.2275 15.0944 20.8975C13.7697 19.5674 12.7422 18.1111 12.0119 16.5288C11.2816 14.9465 10.9165 13.3702 10.9165 11.7998C10.9165 11.5498 10.9998 11.3401 11.1665 11.1706C11.3332 11.0013 11.5415 10.9167 11.7915 10.9167H14.5094C14.7198 10.9167 14.9055 10.9854 15.0663 11.1227C15.2271 11.2599 15.3294 11.4295 15.3732 11.6315L15.8509 14.0833C15.8839 14.3108 15.877 14.5063 15.83 14.6698C15.783 14.8333 15.6985 14.9706 15.5767 15.0817L13.6521 16.9552C13.9619 17.5224 14.3157 18.059 14.7138 18.565C15.1117 19.0708 15.5425 19.554 16.0063 20.0144C16.4635 20.4717 16.9496 20.8965 17.4646 21.2885C17.9796 21.6806 18.5357 22.0455 19.133 22.3831L21.003 20.4969C21.1334 20.3612 21.2913 20.266 21.4767 20.2115C21.662 20.157 21.8546 20.1437 22.0544 20.1715L24.3684 20.6427C24.5788 20.6983 24.7505 20.8056 24.8836 20.9648C25.0166 21.124 25.0832 21.3045 25.0832 21.5065V24.2083C25.0832 24.4583 24.9985 24.6667 24.8292 24.8333C24.6598 25 24.45 25.0833 24.2 25.0833Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </svg>
                <span className="tooltip_text">+9198050-21966</span>
              </Link>

              {/* <Link to={'/'}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                  <path d="M11 20L10.0739 19.1446C8.0792 17.2813 6.42919 15.6863 5.12386 14.3598C3.81873 13.033 2.7885 11.8629 2.03317 10.8496C1.27783 9.83634 0.750139 8.91947 0.450083 8.09904C0.150028 7.27881 0 6.4537 0 5.62368C0 4.03426 0.528102 2.69968 1.58431 1.61993C2.64031 0.539977 3.94554 0 5.5 0C6.57494 0 7.58328 0.281184 8.525 0.843552C9.46672 1.40592 10.2917 2.22385 11 3.29735C11.7083 2.22385 12.5333 1.40592 13.475 0.843552C14.4167 0.281184 15.4251 0 16.5 0C18.0545 0 19.3597 0.539977 20.4157 1.61993C21.4719 2.69968 22 4.03426 22 5.62368C22 6.4537 21.85 7.27881 21.5499 8.09904C21.2499 8.91947 20.7222 9.83634 19.9668 10.8496C19.2115 11.8629 18.1851 13.033 16.8878 14.3598C15.5904 15.6863 13.9365 17.2813 11.9261 19.1446L11 20ZM11 18.3082C12.9556 16.5009 14.5648 14.9528 15.8278 13.664C17.0907 12.3749 18.0889 11.2565 18.8222 10.3088C19.5556 9.36114 20.0648 8.52165 20.35 7.79036C20.6352 7.05887 20.7778 6.33664 20.7778 5.62368C20.7778 4.37397 20.3704 3.33255 19.5556 2.49941C18.7407 1.66628 17.7222 1.24971 16.5 1.24971C15.5269 1.24971 14.6291 1.5337 13.8065 2.1017C12.9838 2.66969 12.2473 3.5248 11.5971 4.66703H10.4029C9.73704 3.50876 8.99668 2.64959 8.18186 2.08951C7.36705 1.52964 6.47309 1.24971 5.5 1.24971C4.29346 1.24971 3.27882 1.66628 2.45606 2.49941C1.6335 3.33255 1.22222 4.37397 1.22222 5.62368C1.22222 6.33664 1.36481 7.05887 1.65 7.79036C1.93519 8.52165 2.44444 9.36114 3.17778 10.3088C3.91111 11.2565 4.90926 12.3709 6.17222 13.6518C7.43519 14.9327 9.04444 16.4849 11 18.3082Z" fill="#1C1B1F" />
                </svg>
              </Link> */}

              <div className={`${styles}`}>
                {isLoggedIn ? (
                  <div className="Main-header-btn">
                    {/* <AccountDetailDropdown
                      name={name}
                      userType={userType}
                      handleLogout={handleLogout}
                    /> */}

                    <NewUIAccountDetailDropdown
                      name={name}
                      userType={userType}
                      handleLogout={handleLogout}
                    />
                  </div>
                ) : (
                  <NewUILoginBtn />
                  // <LoginBtn />
                )}
              </div>

              <button
                className={styles.toggleMenuBtn}
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="22"
                  viewBox="0 0 30 22"
                  fill="none"
                >
                  <rect y="0.399902" width="30" height="1.2" fill="#333333" />
                  <rect y="10.3999" width="30" height="1.2" fill="#333333" />
                  <rect y="20.3999" width="30" height="1.2" fill="#333333" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <nav
        className={`${styles.mobileNav} ${
          menuOpen ? styles.show : styles.hide
        }`}
        id="NewUIHeader"
      >
        <div className="w-full">
          {" "}
          <div className={styles.mobile_close_btn}>
            <button onClick={() => setMenuOpen(!menuOpen)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#333333"
              >
                <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
              </svg>
            </button>
          </div>
          <div className={styles.mobile_flex}>
            {" "}
            <Link
              to="/"
              className={location.pathname === "/" ? styles.active : ""}
              id="holidays_link"
            >
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_6831_12944"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="35"
                  height="35"
                >
                  <rect width="35" height="35" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_6831_12944)">
                  <path
                    d="M10.8815 29.1667C10.2337 29.1667 9.67918 28.936 9.21786 28.4747C8.75654 28.0134 8.52588 27.4587 8.52588 26.8107V11.6667C8.52588 11.0189 8.75654 10.4644 9.21786 10.0031C9.67918 9.54151 10.2337 9.31073 10.8815 9.31073H14.0227V6.73094C14.0227 6.08295 14.2534 5.5283 14.7147 5.06698C15.176 4.60566 15.7305 4.375 16.3783 4.375H18.6219C19.2697 4.375 19.8242 4.60566 20.2855 5.06698C20.7468 5.5283 20.9775 6.08295 20.9775 6.73094V9.31073H24.1187C24.7665 9.31073 25.321 9.54151 25.7823 10.0031C26.2437 10.4644 26.4743 11.0189 26.4743 11.6667V26.8107C26.4743 27.4587 26.2437 28.0134 25.7823 28.4747C25.321 28.936 24.7665 29.1667 24.1187 29.1667V29.5032C24.1187 29.8043 24.0071 30.0666 23.7837 30.2899C23.5601 30.5133 23.2978 30.625 22.9969 30.625C22.6958 30.625 22.4335 30.5133 22.2101 30.2899C21.9868 30.0666 21.8751 29.8043 21.8751 29.5032V29.1667H13.1251V29.5032C13.1251 29.8043 13.0134 30.0666 12.79 30.2899C12.5667 30.5133 12.3044 30.625 12.0033 30.625C11.7024 30.625 11.4401 30.5133 11.2165 30.2899C10.9931 30.0666 10.8815 29.8043 10.8815 29.5032V29.1667ZM10.8815 27.7083H24.1187C24.3805 27.7083 24.5955 27.6242 24.7637 27.456C24.9319 27.2876 25.016 27.0725 25.016 26.8107V11.6667C25.016 11.4049 24.9319 11.1899 24.7637 11.0217C24.5955 10.8533 24.3805 10.7691 24.1187 10.7691H10.8815C10.6197 10.7691 10.4047 10.8533 10.2365 11.0217C10.0683 11.1899 9.98421 11.4049 9.98421 11.6667V26.8107C9.98421 27.0725 10.0683 27.2876 10.2365 27.456C10.4047 27.6242 10.6197 27.7083 10.8815 27.7083ZM14.7508 13.3492C14.5439 13.3492 14.3709 13.4191 14.2316 13.5589C14.0923 13.6986 14.0227 13.8718 14.0227 14.0784V24.399C14.0227 24.6056 14.0926 24.7788 14.2323 24.9185C14.3723 25.0583 14.5458 25.1282 14.7526 25.1282C14.9594 25.1282 15.1325 25.0583 15.2718 24.9185C15.4113 24.7788 15.481 24.6056 15.481 24.399V14.0784C15.481 13.8718 15.411 13.6986 15.271 13.5589C15.131 13.4191 14.9576 13.3492 14.7508 13.3492ZM20.2476 13.3492C20.0408 13.3492 19.8677 13.4191 19.7284 13.5589C19.5889 13.6986 19.5192 13.8718 19.5192 14.0784V24.399C19.5192 24.6056 19.5892 24.7788 19.7292 24.9185C19.8692 25.0583 20.0426 25.1282 20.2494 25.1282C20.4563 25.1282 20.6293 25.0583 20.7686 24.9185C20.9079 24.7788 20.9775 24.6056 20.9775 24.399V14.0784C20.9775 13.8718 20.9076 13.6986 20.7679 13.5589C20.6279 13.4191 20.4544 13.3492 20.2476 13.3492ZM15.481 9.31073H19.5192V6.73094C19.5192 6.46917 19.4351 6.25406 19.2669 6.08562C19.0987 5.91743 18.8837 5.83333 18.6219 5.83333H16.3783C16.1165 5.83333 15.9015 5.91743 15.7333 6.08562C15.5651 6.25406 15.481 6.46917 15.481 6.73094V9.31073Z"
                    fill="#222222"
                  />
                </g>
              </svg>
              Holidays
            </Link>
            <Link
              to="/accommodation"
              className={
                location.pathname === "/accommodation" ? styles.active : ""
              }
            >
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_6831_12995"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="35"
                  height="35"
                >
                  <rect width="35" height="35" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_6831_12995)">
                  <path
                    d="M5.4969 29.3908C5.06864 29.3908 4.70916 29.2454 4.41846 28.9547C4.12777 28.6641 3.98242 28.3047 3.98242 27.8767V6.1136C3.98242 5.68558 4.12777 5.32622 4.41846 5.03553C4.70916 4.74459 5.06864 4.59912 5.4969 4.59912H15.5929C16.0212 4.59912 16.3807 4.74459 16.6714 5.03553C16.9621 5.32622 17.1074 5.68558 17.1074 6.1136V10.4325H29.5033C29.9315 10.4325 30.291 10.5779 30.5817 10.8689C30.8724 11.1596 31.0177 11.5189 31.0177 11.9469V27.8767C31.0177 28.3047 30.8724 28.6641 30.5817 28.9547C30.291 29.2454 29.9315 29.3908 29.5033 29.3908H5.4969ZM5.44075 27.9325H15.6491V23.5575H5.44075V27.9325ZM5.44075 22.0991H15.6491V17.7241H5.44075V22.0991ZM5.44075 16.2658H15.6491V11.8908H5.44075V16.2658ZM5.44075 10.4325H15.6491V6.05745H5.44075V10.4325ZM17.1074 27.9325H29.5594V11.8908H17.1074V27.9325ZM21.3143 17.7241C21.1077 17.7241 20.9346 17.6542 20.7948 17.5145C20.6551 17.3745 20.5852 17.2011 20.5852 16.9942C20.5852 16.7874 20.6551 16.6142 20.7948 16.4747C20.9346 16.3354 21.1077 16.2658 21.3143 16.2658H24.7917C24.9983 16.2658 25.1715 16.3358 25.3113 16.4758C25.451 16.6158 25.5209 16.7892 25.5209 16.996C25.5209 17.2029 25.451 17.3759 25.3113 17.5152C25.1715 17.6545 24.9983 17.7241 24.7917 17.7241H21.3143ZM21.3143 23.5575C21.1077 23.5575 20.9346 23.4876 20.7948 23.3478C20.6551 23.2078 20.5852 23.0344 20.5852 22.8276C20.5852 22.6207 20.6551 22.4475 20.7948 22.308C20.9346 22.1688 21.1077 22.0991 21.3143 22.0991H24.7917C24.9983 22.0991 25.1715 22.1691 25.3113 22.3091C25.451 22.4491 25.5209 22.6225 25.5209 22.8294C25.5209 23.0362 25.451 23.2093 25.3113 23.3485C25.1715 23.4878 24.9983 23.5575 24.7917 23.5575H21.3143Z"
                    fill="#1C1B1F"
                  />
                </g>
              </svg>
              Hotels
            </Link>
            <Link
              to="/activities"
              className={
                location.pathname === "/activities" ? styles.active : ""
              }
            >
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_6831_13001"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="35"
                  height="35"
                >
                  <rect width="35" height="35" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_6831_13001)">
                  <path
                    d="M12.9989 22.7445L19.2135 20.7419C19.5874 20.6148 19.9038 20.4218 20.1629 20.1629C20.4218 19.9038 20.6148 19.5874 20.7419 19.2135L22.75 12.9927C22.8193 12.7669 22.7676 12.5694 22.5951 12.4002C22.4225 12.2308 22.2245 12.1826 22.0011 12.2555L15.7865 14.2581C15.4126 14.3852 15.0962 14.5782 14.8371 14.8371C14.5782 15.0962 14.3852 15.4126 14.2581 15.7865L12.25 22.0073C12.1807 22.2331 12.2324 22.4306 12.4049 22.5998C12.5775 22.7692 12.7755 22.8174 12.9989 22.7445ZM17.4934 19.1268C17.0397 19.1268 16.6562 18.9679 16.3432 18.6503C16.0299 18.3326 15.8732 17.947 15.8732 17.4934C15.8732 17.0397 16.0321 16.6562 16.3497 16.3432C16.6674 16.0299 17.053 15.8732 17.5066 15.8732C17.9603 15.8732 18.3438 16.0321 18.6568 16.3497C18.9701 16.6674 19.1268 17.053 19.1268 17.5066C19.1268 17.9603 18.9679 18.3438 18.6503 18.6568C18.3326 18.9701 17.947 19.1268 17.4934 19.1268ZM17.5047 30.625C15.6898 30.625 13.9835 30.2806 12.3856 29.5918C10.788 28.903 9.39823 27.9682 8.21625 26.7874C7.03427 25.6066 6.09863 24.2181 5.40932 22.6217C4.71977 21.0255 4.375 19.3199 4.375 17.5047C4.375 15.6898 4.71941 13.9835 5.40823 12.3856C6.09705 10.788 7.03184 9.39823 8.2126 8.21625C9.39337 7.03427 10.7819 6.09863 12.3783 5.40932C13.9745 4.71977 15.6801 4.375 17.4953 4.375C19.3102 4.375 21.0165 4.71941 22.6144 5.40823C24.212 6.09705 25.6018 7.03184 26.7838 8.2126C27.9657 9.39337 28.9014 10.7819 29.5907 12.3783C30.2802 13.9745 30.625 15.6801 30.625 17.4953C30.625 19.3102 30.2806 21.0165 29.5918 22.6144C28.903 24.212 27.9682 25.6018 26.7874 26.7838C25.6066 27.9657 24.2181 28.9014 22.6217 29.5907C21.0255 30.2802 19.3199 30.625 17.5047 30.625ZM17.5 29.1667C20.7514 29.1667 23.5086 28.035 25.7717 25.7717C28.035 23.5086 29.1667 20.7514 29.1667 17.5C29.1667 14.2486 28.035 11.4914 25.7717 9.22833C23.5086 6.965 20.7514 5.83333 17.5 5.83333C14.2486 5.83333 11.4914 6.965 9.22833 9.22833C6.965 11.4914 5.83333 14.2486 5.83333 17.5C5.83333 20.7514 6.965 23.5086 9.22833 25.7717C11.4914 28.035 14.2486 29.1667 17.5 29.1667Z"
                    fill="#1C1B1F"
                  />
                </g>
              </svg>
              Activities
            </Link>
            <Link
              to="/transport"
              className={
                location.pathname === "/transport" ? styles.active : ""
              }
            >
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_6831_13007"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="35"
                  height="35"
                >
                  <rect width="35" height="35" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_6831_13007)">
                  <path
                    d="M7.6281 26.25V28.2691C7.6281 28.5184 7.5406 28.7304 7.3656 28.9049C7.19035 29.0794 6.97756 29.1667 6.72721 29.1667C6.47711 29.1667 6.26565 29.0794 6.09284 28.9049C5.91978 28.7304 5.83325 28.5184 5.83325 28.2691V18.1227C5.83325 17.99 5.84079 17.8572 5.85586 17.7242C5.87068 17.5915 5.90021 17.4594 5.94445 17.3279L8.4331 10.3261C8.58817 9.85918 8.86926 9.47977 9.27638 9.18786C9.6835 8.89596 10.139 8.75 10.6428 8.75H24.357C24.8609 8.75 25.3163 8.89596 25.7235 9.18786C26.1306 9.47977 26.4117 9.85918 26.5667 10.3261L29.0554 17.3279C29.0996 17.4594 29.1292 17.5915 29.144 17.7242C29.1591 17.8572 29.1666 17.99 29.1666 18.1227V28.2691C29.1666 28.5184 29.079 28.7304 28.9037 28.9049C28.7287 29.0794 28.516 29.1667 28.2657 29.1667C28.0156 29.1667 27.804 29.0794 27.631 28.9049C27.4581 28.7304 27.3717 28.5184 27.3717 28.2691V26.25H7.6281ZM7.89752 16.2659H27.1023L25.1788 10.7971C25.1039 10.6102 24.9916 10.4654 24.8419 10.3626C24.6924 10.2597 24.5149 10.2083 24.3092 10.2083H10.6906C10.485 10.2083 10.3074 10.2597 10.1579 10.3626C10.0082 10.4654 9.89593 10.6102 9.82106 10.7971L7.89752 16.2659ZM10.8317 22.8845C11.2855 22.8845 11.6689 22.7258 11.9819 22.4084C12.2952 22.0907 12.4519 21.7051 12.4519 21.2516C12.4519 20.7978 12.2931 20.4144 11.9754 20.1013C11.658 19.788 11.2723 19.6314 10.8186 19.6314C10.365 19.6314 9.9816 19.7902 9.6683 20.1079C9.35525 20.4253 9.19872 20.8109 9.19872 21.2647C9.19872 21.7182 9.35744 22.1016 9.67487 22.4149C9.99254 22.728 10.3781 22.8845 10.8317 22.8845ZM24.1813 22.8845C24.6348 22.8845 25.0182 22.7258 25.3315 22.4084C25.6446 22.0907 25.8011 21.7051 25.8011 21.2516C25.8011 20.7978 25.6424 20.4144 25.325 20.1013C25.0073 19.788 24.6217 19.6314 24.1681 19.6314C23.7144 19.6314 23.3309 19.7902 23.0179 20.1079C22.7046 20.4253 22.5479 20.8109 22.5479 21.2647C22.5479 21.7182 22.7068 22.1016 23.0245 22.4149C23.3419 22.728 23.7275 22.8845 24.1813 22.8845ZM7.29159 24.7917H27.7083V17.7242H7.29159V24.7917Z"
                    fill="#1C1B1F"
                  />
                </g>
              </svg>
              Transport
            </Link>
          </div>
          <Link
            id={styles.links_mobile}
            to="/all-destinations"
            className={
              location.pathname === "/all-destinations" ? styles.active : ""
            }
          >
            Destination
          </Link>
          <Link
            id={styles.links_mobile}
            to="/themes"
            className={location.pathname === "/themes" ? styles.active : ""}
          >
            Themes
          </Link>
        </div>
        <div className={styles.copyright}>
          © Copyright 2025. All Rights Reserved.
        </div>
      </nav>

      {/* <div className={styles.mobile_header_nav}>
        <Link
          to="/"
          className={location.pathname === "/" ? styles.active : ""}
        >
          Holidays
        </Link>
        <Link
          to="/accommodation"
          className={location.pathname === "/accommodation" ? styles.active : ""}
        >
          Hotels
        </Link>
        <Link
          to="/activities"
          className={location.pathname === "/activities" ? styles.active : ""}
        >
          Activities
        </Link>
        <Link
          to="/transport"
          className={location.pathname === "/transport" ? styles.active : ""}
        >
          Transport
        </Link>
      </div> */}
    </>
  );
};

export default NewUiHeader;
